var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoOffers = function SvgNoOffers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 228,
    viewBox: "0 0 437 228",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0157 117.765C31.4161 104.241 36.4506 90.5475 46.0801 80.476C55.4425 70.6852 69.2109 66.2994 82.2782 64.2996C90.9509 62.9719 100.625 61.5942 109.339 61.8914C120.056 62.258 130.275 63.819 141.107 63.033C162.955 61.447 184.256 55.8586 205.459 50.6784C243.604 41.3625 280.289 36.7045 318.392 49.9868C374.345 69.4908 410.804 117.743 428.024 172.827C431.918 185.282 434.875 198.022 437 210.891C423.813 210.891 410.629 210.891 397.442 210.891C365.778 210.891 334.116 210.891 302.452 210.891C264.104 210.891 225.758 210.891 187.41 210.891C154.174 210.891 120.935 210.891 87.6994 210.891C71.1774 210.891 54.6554 210.918 38.1334 210.877C39.1486 206.655 37.9943 202.252 36.9151 198.047C30.2896 172.255 24.2844 144.399 29.0157 117.765Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.877 201.445H384.566",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.213 197.002H345.902",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.59 215.057H74.0137",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.671 77.9846C254.671 77.9846 252.724 93.2612 258.009 94.3722C263.294 95.4832 272.751 95.761 272.751 95.761L275.254 107.427L266.91 126.036L254.393 131.869L238.26 125.481L220.459 104.927L217.121 91.3169C217.121 91.3169 226.3 94.0945 229.081 91.5947C231.863 89.0949 233.535 75.5876 229.081 63.733C224.628 51.8784 235.479 57.4307 235.479 57.4307L256.896 75.2071L254.671 77.9846Z",
    fill: "#FFDE99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.671 77.9846C254.671 77.9846 252.724 93.2612 258.009 94.3722C263.294 95.4832 272.751 95.761 272.751 95.761L275.254 107.427L266.91 126.036L254.393 131.869L238.26 125.481L220.459 104.927L217.121 91.3169C217.121 91.3169 226.3 94.0945 229.081 91.5947C231.863 89.0949 233.535 75.5876 229.081 63.733C224.628 51.8784 235.479 57.4307 235.479 57.4307L256.896 75.2071L254.671 77.9846Z",
    fill: "url(#paint1_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.671 77.9846C254.671 77.9846 252.724 93.2612 258.009 94.3722C263.294 95.4832 272.751 95.761 272.751 95.761L275.254 107.427L266.91 126.036L254.393 131.869L238.26 125.481L220.459 104.927L217.121 91.3169C217.121 91.3169 226.3 94.0945 229.081 91.5947C231.863 89.0949 233.535 75.5876 229.081 63.733C224.628 51.8784 235.479 57.4307 235.479 57.4307L256.896 75.2071L254.671 77.9846Z",
    fill: "url(#paint2_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.326 40.9042C267.326 40.9042 273.22 70.8713 260.553 82.7481C260.094 83.1786 259.469 83.3925 258.84 83.3453C255.366 83.087 243.578 81.6787 239.094 74.3738C233.81 65.7633 230.194 62.708 230.194 62.708C230.194 62.708 223.657 69.5131 221.432 63.9579C219.207 58.4028 220.598 51.4589 227.273 51.4589L242.293 26.4609L257.313 28.1275L267.326 40.9042Z",
    fill: "#FFDE99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.047 54.9304L240.484 56.0414L246.186 66.3184L260.233 79.6507C260.233 79.6507 262.316 78.3202 265.117 76.2648C268.294 69.4709 268.878 60.7938 268.65 53.7333C254.548 51.4501 246.047 54.9304 246.047 54.9304Z",
    fill: "url(#paint3_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248.55 31.0433C248.55 31.0433 247.716 52.986 230.192 54.9302C230.192 54.9302 241.875 52.1527 244.656 36.3206C244.656 36.3206 236.033 56.0413 227.133 52.986C224.354 52.0305 222.691 53.9748 221.709 56.1246C220.346 59.1132 221.511 62.7241 224.499 64.099C226.104 64.8378 228.078 64.8183 230.192 62.7074C230.192 62.7074 234.643 87.1499 226.02 85.7611C226.02 85.7611 231.583 86.0389 230.192 72.9844C230.192 72.9844 223.239 71.3178 216.285 73.2621C209.331 75.2064 197.649 61.0409 203.212 31.0433L214.338 16.3222C214.338 16.3222 243.218 7.97289 257.701 19.2831C258.869 20.1941 260.107 21.0135 261.367 21.794C264.405 23.6827 270.454 30.1406 270.246 51.5972C270.246 51.5972 270.524 43.82 266.073 39.0982C266.073 39.0982 267.731 39.8814 268.154 46.7115C268.154 46.7115 263.57 35.4874 248.55 31.0433Z",
    fill: "#241921"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M208.498 14.9336C208.219 14.3781 207.663 -3.12051 188.471 0.490309C184.185 1.2958 180.841 2.69846 178.235 4.39C169.167 10.2729 169.001 19.6554 169.001 19.6554L182.352 3.54562C182.352 3.54562 199.319 -4.23154 203.213 9.934C203.213 9.934 192.131 -5.08702 175.27 6.06487C170.633 9.13129 167.076 13.5698 164.926 18.6916C161.463 26.941 154.364 41.4287 148.137 38.8206C148.137 38.8206 152.935 47.0449 161.488 48.2643C171.223 49.653 185.943 46.2311 193.583 30.149C194.387 28.4575 195.731 27.0632 197.427 26.266C198.824 25.6105 200.459 25.3633 201.819 26.5993C204.879 29.3769 208.495 16.0446 208.495 16.0446V14.9336H208.498Z",
    fill: "#241921"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.338 16.3217C214.338 16.3217 213.782 11.5998 210.166 11.3221C206.55 11.0443 192.364 31.876 203.212 31.0427C203.212 31.0427 211.835 22.1546 214.338 16.3217Z",
    fill: "#0061FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.338 16.3217C214.338 16.3217 213.782 11.5998 210.166 11.3221C206.55 11.0443 192.364 31.876 203.212 31.0427C203.212 31.0427 211.835 22.1546 214.338 16.3217Z",
    fill: "url(#paint4_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.711 23.6113L204.962 26.2222",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.541 21.3389L206.79 23.9498",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207.723 16.1445L210.974 18.7554",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.494 22.6387L205.746 25.2496",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M205.459 18.959L208.711 21.5699",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M205.299 52.8467C205.299 52.8467 208.915 71.7341 217.259 68.401",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M248.689 27.8496C248.689 27.8496 258.425 28.4051 265.935 38.1266",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.093 120.012C167.093 120.012 187.114 117.865 198.443 118.537C202.401 118.774 205.734 121.568 206.643 125.42C207.903 130.759 210.087 138.666 212.71 142.508C216.006 147.335 213.224 176.269 211.911 188.199H267.09C270.645 180.366 277.243 165.35 280.021 155.84C283.915 142.508 277.796 140.841 276.962 129.453C276.962 129.453 288.366 139.452 291.704 143.341C291.704 143.341 290.313 144.174 290.869 145.285C291.425 146.396 291.704 148.063 291.704 148.063C291.704 148.063 308.949 144.174 312.565 148.618L314.234 146.119L312.008 141.397L309.227 138.897C309.227 138.897 287.253 102.511 279.743 97.7891C272.233 93.0672 264.392 95.1726 264.392 95.1726C264.392 95.1726 267.783 126.12 253.597 124.731C239.412 123.343 224.183 92.5478 224.183 92.5478C224.183 92.5478 222.723 90.0147 217.16 89.737C211.597 89.4592 146.788 99.7362 137.61 108.069C137.61 108.069 132.881 107.791 132.047 111.68C132.047 111.68 125.093 112.235 127.318 120.29L167.093 120.012Z",
    fill: "#16BBD2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M312.384 148.673C312.384 148.673 308.49 171.171 303.484 178.671C303.484 178.671 299.59 175.06 294.027 175.337C294.027 175.337 295.657 157.275 292.895 147.834C292.895 147.834 307.656 144.229 312.384 148.673Z",
    fill: "#FFDE99"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M312.384 148.673C312.384 148.673 308.49 171.171 303.484 178.671C303.484 178.671 299.59 175.06 294.027 175.337C294.027 175.337 295.657 157.275 292.895 147.834C292.895 147.834 307.656 144.229 312.384 148.673Z",
    fill: "url(#paint5_radial)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M293.984 174.343L286.658 169.921C286.658 169.921 280.816 183.253 280.816 187.419C280.816 187.419 282.485 189.642 285.823 181.864L286.658 184.92L290.83 185.475L291.942 184.364L292.499 185.753L293.889 186.031L296.393 184.92L297.505 186.031L300.565 185.753C300.565 185.753 303.625 182.698 303.625 178.531C303.625 174.365 293.984 174.343 293.984 174.343Z",
    fill: "#FFDE99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M288.604 176.032L285.822 181.865L286.657 184.92L290.829 185.476L291.942 184.365L292.498 185.754L293.889 186.032L296.392 184.92L297.504 186.032L300.564 185.754C300.564 185.754 303.624 182.698 303.624 178.532C295.836 174.366 288.604 176.032 288.604 176.032Z",
    fill: "url(#paint6_radial)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M210.179 137.88C210.288 138.155 210.399 138.424 210.51 138.688C210.532 138.738 210.552 138.785 210.574 138.835C210.685 139.099 210.799 139.357 210.916 139.607C210.933 139.646 210.952 139.682 210.969 139.721C211.091 139.985 211.214 140.241 211.336 140.49C211.414 140.646 211.492 140.796 211.57 140.946C211.803 141.39 212.045 141.81 212.287 142.193C212.368 142.321 212.449 142.446 212.532 142.565C212.579 142.632 212.621 142.707 212.666 142.782C212.674 142.799 212.685 142.815 212.693 142.835C212.735 142.913 212.777 142.993 212.816 143.076C212.821 143.09 212.827 143.104 212.833 143.115C212.869 143.196 212.905 143.276 212.938 143.362C212.947 143.379 212.952 143.399 212.961 143.415C212.997 143.51 213.033 143.61 213.069 143.715C213.077 143.737 213.083 143.76 213.091 143.782C213.125 143.879 213.155 143.982 213.186 144.087C213.189 144.099 213.194 144.112 213.197 144.124C213.23 144.237 213.261 144.357 213.292 144.479C213.3 144.507 213.305 144.537 213.314 144.565C213.344 144.69 213.375 144.818 213.403 144.948C213.406 144.96 213.408 144.971 213.408 144.982C213.436 145.107 213.461 145.237 213.486 145.368C213.492 145.398 213.497 145.429 213.503 145.457C213.528 145.596 213.553 145.74 213.578 145.885C213.584 145.912 213.586 145.94 213.592 145.968C213.614 146.101 213.634 146.237 213.653 146.376C213.656 146.404 213.661 146.429 213.664 146.457C213.686 146.612 213.706 146.771 213.725 146.932C213.731 146.968 213.734 147.004 213.739 147.04C213.759 147.198 213.775 147.359 213.792 147.523C213.792 147.534 213.795 147.543 213.795 147.554C213.812 147.726 213.828 147.901 213.845 148.079C213.848 148.12 213.853 148.159 213.856 148.201C213.87 148.376 213.887 148.557 213.901 148.737C213.903 148.765 213.903 148.793 213.906 148.818C213.917 148.984 213.928 149.151 213.94 149.32C213.942 149.362 213.945 149.401 213.948 149.443C213.959 149.631 213.97 149.82 213.981 150.012C213.984 150.054 213.984 150.095 213.987 150.137C213.995 150.315 214.004 150.492 214.012 150.676C214.012 150.704 214.015 150.734 214.015 150.762C214.023 150.962 214.031 151.167 214.037 151.373C214.04 151.42 214.04 151.467 214.043 151.517C214.048 151.726 214.054 151.937 214.059 152.153C214.059 152.162 214.059 152.173 214.059 152.181C214.065 152.39 214.068 152.598 214.07 152.812C214.07 152.862 214.073 152.912 214.073 152.965C214.076 153.178 214.079 153.395 214.081 153.614C214.081 153.653 214.081 153.695 214.081 153.734C214.081 153.931 214.084 154.128 214.084 154.325C214.084 154.37 214.084 154.414 214.084 154.462C214.084 154.687 214.084 154.912 214.081 155.139C214.081 155.189 214.081 155.239 214.081 155.289C214.081 155.503 214.079 155.717 214.076 155.934C214.076 155.959 214.076 155.986 214.076 156.011C214.073 156.245 214.07 156.484 214.065 156.72C214.065 156.775 214.062 156.831 214.062 156.886C214.056 157.122 214.054 157.361 214.048 157.603C214.048 157.634 214.045 157.664 214.045 157.692C214.04 157.911 214.034 158.134 214.029 158.359C214.026 158.414 214.026 158.467 214.023 158.522C214.017 158.764 214.009 159.006 214.001 159.25C213.998 159.297 213.998 159.347 213.995 159.395C213.987 159.614 213.981 159.833 213.973 160.053C213.97 160.097 213.97 160.142 213.967 160.186C213.959 160.431 213.948 160.678 213.94 160.925C213.937 160.986 213.934 161.047 213.931 161.108C213.92 161.353 213.912 161.597 213.901 161.844C213.901 161.855 213.901 161.869 213.898 161.88C213.887 162.133 213.876 162.389 213.862 162.644C213.859 162.705 213.856 162.766 213.853 162.83C213.842 163.083 213.828 163.339 213.814 163.591C213.812 163.628 213.812 163.661 213.809 163.697C213.798 163.93 213.784 164.164 213.773 164.397C213.77 164.452 213.767 164.508 213.764 164.564C213.75 164.814 213.737 165.066 213.723 165.319C213.72 165.377 213.714 165.438 213.712 165.497C213.698 165.733 213.684 165.966 213.67 166.202C213.667 166.233 213.667 166.266 213.664 166.297C213.648 166.555 213.634 166.813 213.617 167.072C213.614 167.133 213.609 167.197 213.606 167.258C213.589 167.519 213.572 167.783 213.556 168.044C213.556 168.052 213.556 168.061 213.553 168.069C213.536 168.327 213.52 168.585 213.5 168.844C213.497 168.897 213.492 168.952 213.489 169.005C213.472 169.263 213.453 169.521 213.433 169.78C213.431 169.827 213.428 169.871 213.422 169.919C213.406 170.152 213.389 170.383 213.372 170.616C213.369 170.663 213.367 170.708 213.361 170.755C213.342 171.01 213.322 171.266 213.303 171.519C213.297 171.577 213.294 171.632 213.289 171.691C213.269 171.949 213.25 172.207 213.228 172.463C213.228 172.466 213.228 172.466 213.228 172.468C213.208 172.73 213.186 172.988 213.166 173.246C213.161 173.305 213.158 173.366 213.152 173.424C213.133 173.68 213.111 173.935 213.091 174.188C213.088 174.21 213.088 174.232 213.086 174.254C213.066 174.499 213.044 174.741 213.024 174.982C213.022 175.027 213.016 175.071 213.013 175.113C212.991 175.365 212.972 175.615 212.949 175.865C212.947 175.913 212.941 175.96 212.938 176.004C212.919 176.238 212.897 176.471 212.877 176.704C212.874 176.726 212.874 176.749 212.871 176.774C212.849 177.029 212.827 177.282 212.805 177.535C212.802 177.576 212.796 177.615 212.794 177.657C212.749 178.165 212.702 178.665 212.657 179.16C212.655 179.196 212.652 179.232 212.646 179.265C212.624 179.507 212.602 179.748 212.579 179.987C212.577 180.018 212.574 180.048 212.571 180.079C212.549 180.31 212.527 180.535 212.507 180.762C212.504 180.782 212.504 180.798 212.502 180.818C212.479 181.057 212.454 181.293 212.432 181.526C212.429 181.562 212.424 181.598 212.421 181.637C212.399 181.865 212.376 182.09 212.354 182.312C212.354 182.318 212.354 182.32 212.354 182.326C212.332 182.557 212.31 182.784 212.285 183.012C212.282 183.045 212.279 183.079 212.273 183.112C212.229 183.565 212.182 184.009 212.137 184.443C212.134 184.465 212.132 184.487 212.132 184.506C212.109 184.723 212.087 184.94 212.065 185.151C212.065 185.162 212.062 185.173 212.062 185.187C212.04 185.401 212.018 185.612 211.995 185.82C211.995 185.823 211.995 185.826 211.995 185.831C211.973 186.034 211.954 186.234 211.931 186.431C211.929 186.462 211.926 186.49 211.923 186.52C211.881 186.909 211.84 187.287 211.801 187.651C211.798 187.67 211.798 187.689 211.795 187.706C211.776 187.892 211.756 188.076 211.734 188.253H266.913C266.927 188.223 266.941 188.192 266.955 188.162C267.035 187.984 267.119 187.801 267.202 187.617C267.23 187.553 267.261 187.49 267.291 187.423C267.388 187.206 267.489 186.984 267.592 186.759C267.622 186.69 267.653 186.62 267.686 186.551C267.761 186.381 267.839 186.209 267.917 186.034C267.959 185.942 268 185.848 268.042 185.754C268.139 185.537 268.24 185.315 268.34 185.092C268.387 184.987 268.434 184.881 268.482 184.773C268.548 184.623 268.615 184.473 268.682 184.323C268.74 184.195 268.796 184.065 268.854 183.934C268.927 183.77 268.999 183.606 269.071 183.443C269.152 183.257 269.235 183.07 269.319 182.884C269.38 182.745 269.441 182.607 269.502 182.465C269.569 182.315 269.636 182.162 269.703 182.009C269.756 181.887 269.811 181.765 269.864 181.643C269.975 181.387 270.089 181.126 270.203 180.865C270.259 180.74 270.312 180.615 270.367 180.49C270.437 180.326 270.509 180.165 270.582 180.001C270.632 179.885 270.685 179.765 270.735 179.648C270.863 179.354 270.991 179.057 271.118 178.757C271.163 178.651 271.21 178.546 271.255 178.44C271.333 178.257 271.413 178.074 271.491 177.887C271.533 177.79 271.575 177.696 271.616 177.599C271.758 177.265 271.9 176.932 272.045 176.596C272.086 176.502 272.125 176.407 272.167 176.31C272.251 176.115 272.334 175.918 272.415 175.721C272.454 175.632 272.49 175.54 272.529 175.452C272.676 175.099 272.826 174.746 272.974 174.391C273.013 174.299 273.049 174.21 273.088 174.118C273.171 173.918 273.255 173.718 273.338 173.518C273.377 173.424 273.416 173.33 273.455 173.238C273.602 172.88 273.75 172.521 273.897 172.163C273.933 172.074 273.969 171.985 274.006 171.896C274.089 171.694 274.173 171.491 274.253 171.285C274.292 171.194 274.328 171.099 274.367 171.007C274.512 170.652 274.657 170.294 274.798 169.938C274.837 169.844 274.876 169.746 274.912 169.652C274.993 169.452 275.074 169.252 275.152 169.052C275.191 168.952 275.229 168.855 275.268 168.755C275.405 168.408 275.544 168.061 275.677 167.716C275.716 167.616 275.755 167.516 275.797 167.413C275.872 167.222 275.947 167.027 276.022 166.836C276.064 166.725 276.108 166.616 276.15 166.505C276.275 166.177 276.4 165.852 276.526 165.527C276.567 165.419 276.609 165.308 276.651 165.2C276.72 165.014 276.79 164.83 276.859 164.647C276.904 164.53 276.948 164.411 276.99 164.294C277.101 164 277.21 163.708 277.316 163.416C277.363 163.286 277.413 163.155 277.46 163.025C277.524 162.853 277.585 162.683 277.647 162.514C277.694 162.386 277.738 162.258 277.783 162.133C277.877 161.872 277.969 161.617 278.058 161.358C278.111 161.211 278.164 161.064 278.214 160.917C278.27 160.758 278.325 160.6 278.378 160.442C278.423 160.311 278.47 160.178 278.514 160.047C278.587 159.833 278.659 159.62 278.731 159.408C278.79 159.236 278.848 159.064 278.904 158.892C278.951 158.747 278.998 158.603 279.046 158.458C279.09 158.32 279.135 158.184 279.179 158.047C279.224 157.911 279.265 157.775 279.31 157.642C278.556 158.07 277.858 158.356 275.53 158.545C265.238 159.378 265.238 154.934 251.609 157.711C237.98 160.489 225.741 160.211 223.516 144.101C221.349 128.416 213.225 113.826 196.258 112.715C179.291 111.604 162.955 116.779 162.955 116.779L165.534 120.084L166.91 120.075C166.91 120.075 166.919 120.075 166.93 120.073C166.935 120.073 166.941 120.073 166.949 120.07C166.958 120.07 166.966 120.067 166.977 120.067C166.988 120.067 166.999 120.064 167.01 120.064C167.027 120.062 167.049 120.062 167.072 120.059C167.088 120.056 167.105 120.056 167.125 120.053C167.141 120.05 167.161 120.05 167.18 120.048C167.208 120.045 167.233 120.042 167.261 120.039C167.308 120.034 167.361 120.028 167.417 120.023C167.433 120.02 167.453 120.02 167.472 120.017C167.522 120.012 167.575 120.006 167.631 120C167.647 119.998 167.667 119.998 167.686 119.995C167.745 119.989 167.803 119.984 167.867 119.975C167.892 119.973 167.917 119.97 167.945 119.967C168.003 119.962 168.062 119.956 168.126 119.95C168.162 119.948 168.198 119.942 168.237 119.939C168.315 119.931 168.396 119.923 168.482 119.914C168.501 119.912 168.515 119.912 168.535 119.909C168.64 119.898 168.749 119.887 168.863 119.878C168.896 119.875 168.932 119.873 168.969 119.867C169.052 119.859 169.138 119.85 169.225 119.842C169.266 119.839 169.311 119.834 169.355 119.831C169.45 119.823 169.547 119.812 169.645 119.803C169.675 119.8 169.709 119.798 169.739 119.795C169.85 119.784 169.967 119.773 170.087 119.762C170.117 119.759 170.148 119.756 170.179 119.753C170.326 119.739 170.479 119.725 170.635 119.712C170.638 119.712 170.643 119.712 170.646 119.712C170.788 119.698 170.935 119.687 171.083 119.673C171.138 119.667 171.197 119.662 171.255 119.656C171.366 119.645 171.48 119.637 171.597 119.625C171.65 119.62 171.7 119.617 171.753 119.612C171.875 119.601 172 119.589 172.128 119.578C172.178 119.573 172.229 119.57 172.279 119.564C172.434 119.551 172.593 119.537 172.757 119.523C172.779 119.52 172.802 119.52 172.824 119.517C173.007 119.501 173.194 119.487 173.383 119.47C173.433 119.464 173.483 119.462 173.533 119.456C173.675 119.445 173.817 119.431 173.964 119.42C174.028 119.414 174.092 119.409 174.153 119.403C174.292 119.392 174.434 119.381 174.576 119.37C174.637 119.364 174.698 119.359 174.76 119.356C174.91 119.345 175.06 119.331 175.213 119.32C175.271 119.314 175.33 119.312 175.388 119.306C175.806 119.273 176.231 119.239 176.668 119.209C176.729 119.203 176.787 119.201 176.849 119.195C177.004 119.184 177.157 119.173 177.316 119.162C177.394 119.156 177.474 119.151 177.555 119.145C177.705 119.134 177.855 119.123 178.008 119.112C178.084 119.106 178.159 119.101 178.234 119.095C178.412 119.081 178.593 119.07 178.773 119.056C178.821 119.053 178.868 119.051 178.915 119.045C179.146 119.028 179.377 119.014 179.611 118.998C179.658 118.995 179.705 118.992 179.752 118.989C179.939 118.978 180.128 118.964 180.317 118.953C180.389 118.948 180.462 118.945 180.531 118.939C180.695 118.928 180.862 118.917 181.026 118.909C181.11 118.903 181.19 118.898 181.274 118.892C181.441 118.881 181.608 118.873 181.777 118.862C181.85 118.856 181.925 118.853 181.997 118.848C184.795 118.684 187.721 118.553 190.525 118.498C190.739 118.492 190.951 118.489 191.165 118.487C191.17 118.487 191.176 118.487 191.179 118.487C191.457 118.481 191.732 118.478 192.008 118.476C192.074 118.476 192.144 118.476 192.211 118.473C192.77 118.467 193.323 118.467 193.866 118.47C193.932 118.47 193.996 118.47 194.063 118.47C194.603 118.473 195.134 118.481 195.654 118.495C195.718 118.498 195.782 118.498 195.846 118.501C196.363 118.514 196.867 118.531 197.356 118.553C197.418 118.556 197.479 118.559 197.537 118.562C197.782 118.573 198.024 118.587 198.26 118.601C199.251 118.659 200.199 118.878 201.084 119.234C201.287 119.314 201.487 119.406 201.682 119.503C201.707 119.517 201.734 119.528 201.759 119.539C201.946 119.631 202.127 119.731 202.305 119.837C202.335 119.856 202.369 119.875 202.399 119.892C202.574 119.998 202.744 120.112 202.911 120.228C202.939 120.248 202.967 120.267 202.994 120.289C203.164 120.412 203.331 120.539 203.492 120.675C203.506 120.687 203.52 120.7 203.534 120.712C203.693 120.848 203.848 120.986 203.999 121.134C204.012 121.148 204.024 121.159 204.038 121.17C204.188 121.317 204.33 121.47 204.469 121.628C204.491 121.653 204.513 121.678 204.535 121.706C204.669 121.861 204.797 122.02 204.919 122.186C204.942 122.217 204.964 122.245 204.986 122.275C205.108 122.442 205.225 122.614 205.336 122.792C205.35 122.817 205.367 122.842 205.381 122.864C205.495 123.05 205.606 123.242 205.706 123.436C205.804 123.628 205.896 123.825 205.979 124.025C206.004 124.083 206.026 124.145 206.051 124.203C206.113 124.353 206.168 124.503 206.218 124.658C206.24 124.72 206.26 124.781 206.279 124.845C206.346 125.056 206.407 125.267 206.457 125.483C206.51 125.706 206.563 125.933 206.619 126.161C206.633 126.219 206.647 126.278 206.66 126.336C206.716 126.567 206.772 126.8 206.833 127.036C206.836 127.044 206.836 127.053 206.838 127.058C206.897 127.294 206.958 127.533 207.019 127.775C207.036 127.836 207.05 127.897 207.067 127.958C207.194 128.453 207.325 128.961 207.464 129.475C207.481 129.539 207.5 129.605 207.517 129.669C207.656 130.186 207.801 130.708 207.954 131.233C207.973 131.297 207.99 131.363 208.009 131.427C208.085 131.691 208.162 131.958 208.243 132.222C208.36 132.616 208.482 133.013 208.605 133.408C208.727 133.802 208.855 134.197 208.983 134.585C209.111 134.974 209.244 135.363 209.378 135.746V135.749C209.511 136.133 209.648 136.51 209.787 136.882C209.898 137.18 210.012 137.471 210.126 137.76C210.146 137.796 210.162 137.838 210.179 137.88Z",
    fill: "url(#paint7_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.252 210.898H91.9295C90.1772 210.898 88.7559 209.479 88.7559 207.729V127.146H174.425V207.729C174.425 209.479 173.004 210.898 171.252 210.898Z",
    fill: "#EC1659"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.608 127.277H174.424V207.726C174.424 209.476 173.003 210.896 171.25 210.896H130.385C130.671 210.979 130.972 211.026 131.286 211.026H210.608C212.361 211.026 213.782 209.607 213.782 207.857V130.447C213.782 128.697 212.361 127.277 210.608 127.277Z",
    fill: "#EECFF8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 134.472C212.57 134.472 217.677 139.091 219.068 141.591C220.459 144.09 220.459 147.146 221.571 151.312C221.571 151.312 217.677 150.756 215.452 142.979C213.227 135.202 212.57 134.472 212.57 134.472Z",
    fill: "url(#paint8_radial)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M167.332 133.536L174.425 134.472V130.547L168.445 131.036L167.332 133.536Z",
    fill: "url(#paint9_radial)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M159.822 144.923H74.1523L88.8942 127.146H174.564L159.822 144.923Z",
    fill: "#F9C1DA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M266.787 188.531C270.105 181.232 276.261 167.272 279.312 157.631C278.558 158.059 277.86 158.345 275.532 158.534C265.24 159.367 265.24 154.923 251.611 157.701C237.982 160.478 225.743 160.2 223.518 144.091C221.351 128.406 213.227 113.815 196.26 112.704C179.293 111.593 162.957 116.768 162.957 116.768L165.535 120.073L166.912 120.065C166.912 120.065 174.347 119.268 182.719 118.795C183.579 118.748 184.447 118.701 185.317 118.662C185.754 118.643 186.191 118.623 186.625 118.606C187.932 118.554 189.239 118.512 190.521 118.487C190.736 118.482 190.947 118.479 191.161 118.476C193.706 118.437 196.137 118.465 198.26 118.59C199.25 118.648 200.198 118.868 201.083 119.223C203.069 120.023 204.718 121.512 205.703 123.428C206.031 124.067 206.287 124.753 206.457 125.475C206.929 127.478 207.53 129.842 208.237 132.217C208.354 132.611 208.476 133.008 208.598 133.403C208.721 133.797 208.849 134.191 208.977 134.58C209.105 134.972 209.238 135.358 209.372 135.741C209.505 136.125 209.641 136.502 209.78 136.874C210.267 138.177 210.785 139.405 211.324 140.488C211.633 141.107 211.95 141.68 212.275 142.191C212.356 142.318 212.437 142.443 212.52 142.563C213.669 144.243 214.078 148.846 214.072 154.634C214.083 165.494 212.587 180.688 211.725 188.531H266.787Z",
    fill: "url(#paint10_radial)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M194.311 127.702H175.675L174.424 130.48V134.646C174.424 134.646 189.027 134.924 194.868 141.312C200.709 147.701 204.325 177.143 213.782 174.921V143.418L194.311 127.702Z",
    fill: "url(#paint11_radial)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M166.218 137.146L174.563 127.146H128.668C128.668 127.146 122.549 137.701 166.218 137.146Z",
    fill: "url(#paint12_radial)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.933 115.331C129.641 115.642 127.747 117.342 127.293 119.606C126.885 121.656 127.096 124.481 129.224 127.98C133.76 135.444 172.1 130.119 192.889 133.847C194.511 134.138 195.954 135.058 196.914 136.396C199.339 139.777 204.015 146.654 205.436 151.312C207.383 157.7 209.609 166.866 210.999 170.477C210.999 170.477 211.973 170.894 212.251 167.838V155.895L214.476 163.394L215.589 170.616C215.589 170.616 216.979 170.616 218.092 167.561C218.092 167.561 219.205 168.394 219.761 164.783V160.339L221.43 156.45L219.205 143.674C219.205 143.674 210.732 130.602 207.041 127.833C203.35 125.064 180.82 121.731 163.853 117.009C150.889 113.401 137.521 114.576 131.933 115.331Z",
    fill: "#FFDE99"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.072 139.504C199.072 139.504 199.075 139.504 199.072 139.504C202.135 135.949 204.808 131.827 206.14 127.311C200.571 124.645 179.766 121.439 163.853 117.009C150.889 113.401 137.521 114.576 131.933 115.331C129.641 115.642 127.747 117.342 127.293 119.606C126.885 121.656 127.096 124.481 129.224 127.98C133.527 135.058 168.24 130.633 189.543 133.338C193.242 133.808 196.569 135.821 198.666 138.902C198.8 139.099 198.936 139.299 199.072 139.504Z",
    fill: "url(#paint13_radial)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M215.59 170.616C215.59 170.616 216.981 170.616 218.094 167.561C218.094 167.561 219.206 168.394 219.763 164.783V160.339L221.431 156.45L219.387 144.935C219.387 144.935 212.948 149.368 209.332 148.257L212.392 155.756L212.464 156.606L214.478 163.394L215.59 170.616Z",
    fill: "url(#paint14_radial)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.173 141.589C289.994 140.201 276.643 120.202 276.643 120.202V129.368L276.796 129.668C276.79 129.615 276.787 129.563 276.782 129.507C276.782 129.507 288.186 139.506 291.523 143.395C291.523 143.395 290.133 144.228 290.689 145.339C291.245 146.45 291.523 148.117 291.523 148.117C291.523 148.117 292.644 147.864 294.375 147.561C294.386 146.836 294.742 145.881 296.113 144.922C298.894 142.978 310.298 144.922 310.298 144.922C310.298 144.922 308.351 142.978 299.173 141.589Z",
    fill: "url(#paint15_radial)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M205.16 94.094C205.16 94.094 220.18 90.4832 222.684 96.0383",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270.385 96.7314C270.385 96.7314 277.617 98.1202 280.954 101.731",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M251.626 150.845C251.626 150.845 243.968 155.043 237.268 150.953",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M200.571 22.8499C200.571 22.8499 196.12 20.3501 189.445 31.1825C182.68 42.1594 174.425 42.2928 166.637 41.4595",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M405.53 76.4565H396.287L399.213 67.2295H408.456L405.53 76.4565Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M362.096 91.4167C363.225 90.0107 365.356 89.3771 366.51 90.1024C367.063 90.4497 367.383 91.0388 367.887 91.4417C368.599 92.0141 369.684 92.1864 370.793 91.903C371.906 91.6223 373.027 90.8887 373.8 89.9412",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M411.649 48.4028H402.406L405.332 39.1758H414.575L411.649 48.4028Z",
    fill: "url(#paint16_radial)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M407.931 60.1185H398.691L401.618 50.8887H410.858L407.931 60.1185Z",
    fill: "url(#paint17_radial)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M404.219 71.8314H394.979L397.905 62.6016H407.145L404.219 71.8314Z",
    fill: "url(#paint18_radial)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M406.045 43.758L407.021 46.1967L412.882 41.3193",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M374.279 84.3723H338.768C337.581 84.3723 336.902 83.4112 337.252 82.2252L343.018 62.7379C343.369 61.5518 344.615 60.5908 345.803 60.5908H381.314C382.502 60.5908 383.18 61.5518 382.83 62.7379L377.064 82.2252C376.713 83.4112 375.467 84.3723 374.279 84.3723Z",
    fill: "#FB8F8F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M382.748 77.984H345.637C344.45 77.984 343.771 77.023 344.122 75.8369L350.168 55.3941C350.519 54.2081 351.765 53.2471 352.953 53.2471H390.063C391.251 53.2471 391.93 54.2081 391.579 55.3941L385.532 75.8369C385.182 77.023 383.936 77.984 382.748 77.984Z",
    stroke: "#FB8F8F",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M378.004 79.0488H338.195L339.35 75.1436H379.161L378.004 79.0488Z",
    fill: "url(#paint19_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M351.453 70.1179H346.931C346.316 70.1179 345.963 69.6207 346.146 69.0041L347.028 66.021C347.209 65.4072 347.857 64.9072 348.472 64.9072H352.994C353.609 64.9072 353.962 65.4044 353.779 66.021L352.897 69.0041C352.716 69.6207 352.068 70.1179 351.453 70.1179Z",
    fill: "url(#paint20_radial)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M348.869 64.9072L348.154 67.3265L348.808 68.8152L348.424 70.1179",
    stroke: "#F9C1DA",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M348.807 68.8165L350.476 67.3271H353.391",
    stroke: "#F9C1DA",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M352.302 64.9072L351.584 67.3265",
    stroke: "#F9C1DA",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M374.28 84.3723C375.467 84.3723 376.714 83.4112 377.064 82.2252L382.83 62.7379C383.18 61.5518 382.502 60.5908 381.314 60.5908H374.975L357.207 84.3723H374.28Z",
    fill: "url(#paint21_radial)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M389.974 124.925H311.309L329.936 67.1514H408.602L389.974 124.925Z",
    fill: "url(#paint22_radial)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M391.102 104.232H324.068L326.015 98.9551H393.049L391.102 104.232Z",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M388.043 111.453H321.01L322.957 106.176H389.99L388.043 111.453Z",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M385.539 118.675H318.506L320.453 113.397H387.487L385.539 118.675Z",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M385.763 190.49H245.896C245.173 190.49 244.586 189.904 244.586 189.181V187.293C244.586 186.57 245.173 185.984 245.896 185.984H385.763C386.486 185.984 387.073 186.57 387.073 187.293V189.181C387.073 189.904 386.486 190.49 385.763 190.49Z",
    fill: "#FB8F8F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M385.761 190.49H302.289C301.565 190.49 300.979 189.904 300.979 189.181V187.293C300.979 186.57 301.565 185.984 302.289 185.984H385.764C386.487 185.984 387.074 186.57 387.074 187.293V189.181C387.071 189.904 386.484 190.49 385.761 190.49Z",
    fill: "#F9C1DA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M406.516 115.402H325.736C324.649 115.402 323.681 116.1 323.342 117.133L302.072 181.55C301.535 183.18 302.75 184.858 304.466 184.858H385.249C386.336 184.858 387.304 184.161 387.644 183.128L408.914 118.71C409.451 117.08 408.235 115.402 406.516 115.402Z",
    fill: "#EECFF8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M291.637 189.362H284.756C284.372 189.362 284.061 189.051 284.061 188.667V188.178C284.061 187.795 284.372 187.483 284.756 187.483H291.637C292.021 187.483 292.333 187.795 292.333 188.178V188.667C292.333 189.051 292.021 189.362 291.637 189.362Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M381.678 189.551H374.797C374.413 189.551 374.102 189.24 374.102 188.857V188.368C374.102 187.984 374.413 187.673 374.797 187.673H381.678C382.062 187.673 382.374 187.984 382.374 188.368V188.857C382.374 189.24 382.062 189.551 381.678 189.551Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M277.913 189.551H271.031C270.647 189.551 270.336 189.24 270.336 188.857V188.368C270.336 187.984 270.647 187.673 271.031 187.673H277.913C278.297 187.673 278.608 187.984 278.608 188.368V188.857C278.608 189.24 278.297 189.551 277.913 189.551Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M296.712 189.551H296.223C295.839 189.551 295.527 189.24 295.527 188.857V188.368C295.527 187.984 295.839 187.673 296.223 187.673H296.712C297.096 187.673 297.408 187.984 297.408 188.368V188.857C297.408 189.24 297.096 189.551 296.712 189.551Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M407.999 115.886C407.587 115.586 407.081 115.402 406.516 115.402H325.737C324.649 115.402 323.681 116.1 323.342 117.133L302.322 180.792L407.999 115.886Z",
    fill: "url(#paint23_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M394.425 120.322L368.857 136.09",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2334 160.3H20.0234V210.699H92.2334V160.3Z",
    fill: "#DEF4FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0225 160.3H1V210.699H20.0225V160.3Z",
    fill: "url(#paint24_radial)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M126.165 150.938H65.9902V211.028H126.165V150.938Z",
    fill: "#FFD85E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M106.79 150.938H46.6152V211.028H106.79V150.938Z",
    fill: "#FEC100"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5511 150.938H60.293V169.148H70.5511V150.938Z",
    fill: "#FB8F8F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M226.578 177.977H172.061V216.029H226.578V177.977Z",
    fill: "#F2F6FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M199.318 177.977H144.801V216.029H199.318V177.977Z",
    fill: "url(#paint25_radial)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1 160.3L10.318 172.316L20.0225 160.3",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19531 210.89L10.5133 199.646L19.8285 210.89",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5117 199.646V172.51",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M199.318 177.977L213.782 189.362L226.577 177.977",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M199.18 216.168L213.643 207.835L226.438 216.168",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M213.643 189.226V207.835",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9989 61.8623C55.6137 63.6872 55.6694 66.4619 57.1296 68.2285C58.8152 70.2672 61.8748 70.8088 63.4658 72.9197C64.6786 74.528 64.7314 76.9139 63.591 78.5749",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M318.645 24.7943C319.796 24.7943 320.731 23.8616 320.731 22.7111C320.731 21.5606 319.796 20.6279 318.645 20.6279C317.493 20.6279 316.559 21.5606 316.559 22.7111C316.559 23.8616 317.493 24.7943 318.645 24.7943Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M130.061 81.6973L127.375 82.4192L128.098 85.1012L130.784 84.3793L130.061 81.6973Z",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 97.2529L426.096 97.9748L426.819 100.657L429.506 99.9349L428.783 97.2529Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M342.146 223.945C342.146 223.945 352.16 212.835 366.624 218.945",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9133 17.5713L78.4629 24.2374",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2109 223.944L60.3832 227",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M390.184 156.122C390.871 159.369 393.794 162.013 397.096 162.38C398.308 162.513 399.538 162.372 400.75 162.51C402.987 162.769 405.084 164.044 406.341 165.907",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.785 10.953) rotate(13.7966) scale(277.685 169.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9011,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.215 80.8061) scale(29.6967 29.6549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.161 86.2793) scale(49.1915 49.1222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.322 47.7554) scale(28.0056 27.9661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.991 45.7463) scale(42.2599 42.2002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.784 139.8) scale(43.3089 43.2479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.552 173.571) scale(15.6487 15.6266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187 144.196) scale(51.1353 51.0631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.41 139.629) scale(19.6336 19.6059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.995 120.864) scale(20.7088 20.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.389 155.228) scale(53.4394 53.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.473 123.249) scale(49.3053 49.2358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.642 114.444) scale(39.6812 39.6251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.479 139.012) scale(115.399 115.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.113 141.362) scale(25.7701 25.7337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.984 160.097) scale(46.1634 46.0982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0936,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(402.773 35.0458) scale(30.1369 30.0945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.514 42.0627) scale(54.7076 54.6303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393.919 46.2729) scale(43.1914 43.1302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 338.774,
    y1: 77.097,
    x2: 375.381,
    y2: 87.9258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#F9C1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EECFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.559 58.4566) scale(23.2379 28.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(378.572 43.4261) scale(34.3858 34.3373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#F9C1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EECFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(374.754 157.401) scale(183.59 183.331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0281,
    stopColor: "#106CFE",
    stopOpacity: 0.9719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1219,
    stopColor: "#408BFE",
    stopOpacity: 0.8781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    stopColor: "#6AA7FE",
    stopOpacity: 0.7789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3241,
    stopColor: "#8EBFFF",
    stopOpacity: 0.6759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4318,
    stopColor: "#ABD2FF",
    stopOpacity: 0.5682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#C2E1FF",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#D2ECFF",
    stopOpacity: 0.3304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#DBF2FF",
    stopOpacity: 0.1906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 302.319,
    y1: 148.096,
    x2: 407.999,
    y2: 148.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#F9C1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EECFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2074 119.221) scale(112.677 163.046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.036 125.2) scale(121.923 121.751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoOffers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-offers.61d5f321.svg";
export { ForwardRef as ReactComponent };